export const HOOKS = {
	CHANGE_COMPONENT_VIEW_MODE: 'CHANGE_COMPONENT_VIEW_MODE',
	SWITCH_VIEW_MODE: 'SWITCH_VIEW_MODE',
	AFTER_NAVIGATE_TO_PAGE: 'AFTER_NAVIGATE_TO_PAGE',
	AFTER_NAVIGATE_TO_PAGE_DONE: 'AFTER_NAVIGATE_TO_PAGE_DONE',
	CONNECTION_AFTER_DISCONNECT: 'AFTER_DISCONNECT',
	AFTER_CHANGE_LANGUAGE: 'AFTER_CHANGE_LANGUAGE',
	WIXCODE_UPDATE_MODEL: 'WIXCODE.UPDATE_MODEL',
}

export const HOOKS_BLACK_LIST = [
	HOOKS.CHANGE_COMPONENT_VIEW_MODE,
	HOOKS.SWITCH_VIEW_MODE,
	HOOKS.AFTER_NAVIGATE_TO_PAGE,
	HOOKS.AFTER_NAVIGATE_TO_PAGE_DONE,
	HOOKS.AFTER_CHANGE_LANGUAGE,
	HOOKS.WIXCODE_UPDATE_MODEL,
]

export const SOURCES = { AFTER_PROP_UPDATE: 'AFTER_PROP_UPDATE' }

export const DEBOUNCE_REFRESH_APPS_TIME = 500 as const
